/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

/**
 * @module enervee_utils.product_sections
 */
function ecoViewDirective() {
    return {
        restrict: 'E',
        scope: {
            productEfficiency: '=',
            productCtrl: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: ecoViewController,
        template: require('./ecoViewView.html')
    };
}

ecoViewController.$inject = [
    '$scope',
    'ProductService',
    '$timeout',
    'UtilService',
    'CmsContentService',
    '$filter',
    'AnalyticsService',
];
function ecoViewController (
    $scope,
    ProductService,
    $timeout,
    UtilService,
    CmsContentService,
    $filter,
    AnalyticsService
) {

    this.$onInit = function () {
        var vm = this;
        vm.showModelNumber = ProductService.getDetailsPageConfig('show_model_number_under_efficiency_section');
        vm.isEcoViewEnabled = ProductService.getDetailsPageConfig('is_eco_view_enabled');

        vm.efficiencyLevels = UtilService.getSiteSetting('efficiency_levels') || [];
        vm.efficiencyLevelTitles = {};

        vm.efficiencyLevels.forEach(function (level) {
            CmsContentService.getMarketPlaceText('product_attributes:efficiency_description:' + level.cms_key).then(function (text) {
                vm.efficiencyLevelTitles[level.cms_key] = text;
            });
        });

        /**
         * Eco-view related functionality
         */
        if (vm.isEcoViewEnabled) {

            var sortedScoreIntervals, _ecoViewData, currentInterval;

            // Eco View slider logic

            var updateEcoViewScope = function (selectedScore, user_updated) {

                var interval;
                var cities;
                var chosenCity;

                // find slider interval
                for (var i = sortedScoreIntervals.length - 1; i >= 0; i -= 1) {
                    if (selectedScore >= sortedScoreIntervals[i]) {
                        interval = sortedScoreIntervals[i];
                        break;
                    }
                }

                if (!interval) {
                    interval = sortedScoreIntervals[0];
                }

                // only update view if interval has changed
                if (interval !== currentInterval) {
                    currentInterval = interval;

                    cities = _ecoViewData[interval];
                    chosenCity = cities[Math.floor(Math.random() * cities.length)];

                    vm.ecoViewCityName = chosenCity.city_name;
                    vm.ecoViewCityPopulation = chosenCity.population;
                    vm.ecoViewCityImageLink = chosenCity.image_link;
                    vm.energyConsumptionIndicator = chosenCity.save_or_waste;

                    // define whether score would save of waste energy
                    vm.isSaving = (chosenCity.save_or_waste !== "waste");
                }
            };

            $scope.$watch('vm.productEfficiency.ecoViewData', function () {
                _ecoViewData = vm.productEfficiency.ecoViewData;
                if (_ecoViewData) {
                    sortedScoreIntervals = Object.keys(_ecoViewData).map(Number).sort(function (a, b) {
                        return a - b;
                    });

                    if (sortedScoreIntervals.length < 1) {
                        vm.isEcoViewEnabled = false;
                        return;
                    }

                    updateEcoViewScope(vm.productEfficiency.efficiency_score);
                }
            });

            vm.trackEcoViewed = function () {
                AnalyticsService.reportEvent('Eco Viewed', {
                    ecoview_city: vm.ecoViewCityName,
                    ecoview_population: vm.ecoViewCityPopulation,
                }, vm.productCtrl.productDetailData);
            };

            /**
             * Track slider value change
             * */
            var previous_value;
            var sendSegmentValueChanged = function(value){
                // don't send if nothing changed
                if (value === previous_value)
                    return;
                previous_value = vm.slider.value;
                AnalyticsService.reportEvent('Eco Engaged', {
                    ecoview_city: vm.ecoViewCityName,
                    ecoview_population: vm.ecoViewCityPopulation,
                    ecoview_score: value,
                }, vm.productCtrl.productDetailData);
            };

            /**
             * angular slider to show energy savings and waste,
             * based on energy score of product purchased
             */
            vm.slider = {
                value: vm.productEfficiency.efficiency_score,
                options: {
                    floor: 0,
                    ceil: 100,
                    showTicksValues: true,
                    ticksArray: [0, 50, 75, 90, 100],
                    onChange: function () {
                        updateEcoViewScope(vm.slider.value);
                    },
                    onEnd: function () {
                        sendSegmentValueChanged(vm.slider.value);
                    }
                }
            };

            vm.productCtrl.refreshSlider = function () {
                $timeout(function () {
                    $scope.$broadcast('rzSliderForceRender');
                });
            };

            previous_value = vm.slider.value;
        }

        // Specifying whether to use 'a' or 'an' before the category names.
        vm.categoryName = vm.productEfficiency.category.name.toLowerCase();
        vm.categoryId = vm.productEfficiency.category.id;

        $scope.$watch('vm.ecoViewCityPopulation', renderEcoViewCityPopDynamicContent);
        $scope.$watch('vm.ecoViewCityName', renderEcoViewCityNameDynamicContent);
        $scope.$watch('vm.slider.value', renderEcoViewSentencePrefix);

        /**
         * Renders the eco_view_population cms value with the latest
         * ecoViewCityPopulation value as the population count
         */
        function renderEcoViewCityPopDynamicContent () {
            CmsContentService.getMarketPlaceText(
                'details_page:eco_view_population',
                {
                    'population': vm.ecoViewCityPopulation,
                }
            ).then(function (text) {
                vm.ecoViewPopulationSentence = text;
            });
        };

        /**
         * Renders the eco_view_sentence_save and eco_view_sentence_waste cms values with the latest
         * ecoViewCityName value as the city name
         */
        function renderEcoViewCityNameDynamicContent () {
            CmsContentService.getMarketPlaceText(
                'details_page:eco_view_sentence_save',
                {
                    'city_name': vm.ecoViewCityName,
                }
            ).then(function (text) {
                vm.ecoViewSentenceSave = text;
            });

            CmsContentService.getMarketPlaceText(
                'details_page:eco_view_sentence_waste',
                {
                    'city_name': vm.ecoViewCityName,
                }
            ).then(function (text) {
                vm.ecoViewSentenceWaste = text;
            });
        }

        /**
         * Renders the eco_view_sentence_prefix cms value with the latest selected enervee score value
         * from the slider
         */
        function renderEcoViewSentencePrefix() {
            CmsContentService.getMarketPlaceText(
                'details_page:eco_view_sentence_prefix',
                {
                    enervee_score_text: [
                            '{enervee_score}<sup>&reg;</sup>',
                            {
                                'enervee_score': "details_page:enervee_score"
                            }
                        ],
                    enervee_score_value: vm.slider.value,
                    a_or_an: $filter('aOrAn')(vm.productEfficiency.category.name),
                    category_name: $filter('lowercase')(vm.productEfficiency.category.name),
                    strong_open: '<strong>',
                    strong_close: '</strong>'
                }
            ).then(function(text) {
                vm.ecoViewSentence = text;
            });
        }
    }
}

module.exports = ecoViewDirective;
